import { render, staticRenderFns } from "./InformationPageIndex.vue?vue&type=template&id=0848c7fc&scoped=true&"
import script from "./InformationPageIndex.vue?vue&type=script&lang=ts&"
export * from "./InformationPageIndex.vue?vue&type=script&lang=ts&"
import style0 from "./InformationPageIndex.vue?vue&type=style&index=0&id=0848c7fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848c7fc",
  null
  
)

export default component.exports